import {
  Component,
  ChangeDetectorRef,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import * as _ from 'lodash';

import { BaseDropdownComponent } from '../../_base-dropdown.component';
import { DropdownService } from '../../dropdown.service';


@Component({
  moduleId: module.id,
  selector: 'select-dropdown-menu',
  templateUrl: 'select-dropdown-menu.component.html',
  styleUrls: ['select-dropdown-menu.component.scss']
})
export class SelectDropdownMenuComponent implements OnDestroy {

  /**
   * Dropdown menu alignment
   * https://v4-alpha.getbootstrap.com/components/dropdowns/#menu-alignment
  */
  @HostBinding('class.dropdown-menu') dropownMenu: boolean = true;

  @HostBinding('class.dropdown-menu-right')
  @Input() alignmentRight: boolean = false;

  @HostBinding('class.dropdown-menu-style-dark')
  @Input() darkStyle: boolean = false;

  @Input() items: Array<any> = [];

  @Input() optionGhostValue: string;

  @Input() tabHandle: boolean = true;

  @Input() selectedOption: any;

  @Input() isMultiple: boolean = false;

  @Input() selectedOptions: Array<any> = [];

  @Output() selectedChange = new EventEmitter<any>();

  @ViewChildren('dropdownItem')
  dropdownItems: QueryList<ElementRef>;

  hoveredItem: any;

  get isDropdownOpened(): boolean {
    return this.dropdownService.isOpenedValue;
  }

  constructor(
    private dropdownService: DropdownService,
    private ref: ChangeDetectorRef,
    private elementRef: ElementRef,
  ) {}

  ngOnDestroy() {
    this.setHoveredItem(null);
    this.items = [];
    this.ref.detach();
  }

  onDropdownItemClick(event: MouseEvent, item: any) {
    event.preventDefault();
    this.selectItem(item);
  }

  onDropdownItemCheck(event: MouseEvent, item: any) {
    event.preventDefault();
    this.checkItem(item);
  }

  onDropdownItemHover(item: any) {
    if (!this.isDropdownOpened) { return; }
    this.setHoveredItem(item);
  }

  onSelectedChange(selected: any) {
    this.selectedChange.emit(selected);
  }

  getOptionGhostValue(item: any): string {
    if (this.optionGhostValue) {
      return `${this.optionGhostValue}-option-${item.title || item.id}`;
    } else {
      return `contextual-${item.title}`;
    }
  }

  public setActive(option: any, silent: boolean): void {
    if (this.isMultiple) {
      this.selectedOptions.push(option);
      this.selectedChange.emit(this.items.filter(item => this.selectedOptions.includes(item.option)));
      return;
    }
    const active = _.find(this.items, ['option', option]);
    if (active) { this.selectedOption = option; }
    if (silent) { return; }
    this.selectedChange.emit(active);
  }

  public hoverNextItem(direction: number): void {
    const next = this.getNextHoveredItem(direction);
    if (next) {
      this.setHoveredItem(next);
      this.ref.detectChanges();
      this.scrollToNext(next, direction);
    }
  }

  public hoverFirstItem(): void {
    if (_.size(this.items)) {
      this.setHoveredItem(this.items[0]);
      this.ref.detectChanges();
    }
  }

  public setHoveredItem(item: any): void {
    this.hoveredItem = item;
  }

  public selectHoveredItem(): void {
    if (!this.hoveredItem) {
      if (this.items.length === 1) {
        this.selectItem(this.items[0]);
      } else if (this.selectedOption) {
        const item = _.find(this.items, ['option', this.selectedOption]);
        this.selectItem(item || this.items[0]);
      }
    } else {
      this.selectItem(this.hoveredItem);
    }
  }

  private getNextHoveredItem(direction: number): any {
    const index = _.indexOf(this.items, this.hoveredItem);
    if (index === -1) {
      if (direction === 1) {
        return _.head(this.items);
      } else {
        return _.last(this.items);
      }
    }
    return this.items[index + direction];
  }

  private selectItem(item: any): void {
    if (!item) { return; }
    this.selectedOption = item.option;
    this.selectedChange.emit(item);
    this.dropdownService.close();
  }

  private checkItem(item: any): void {
    if (!item) { return; }
    if (this.selectedOptions.includes(item.option)) {
      this.selectedOptions = this.selectedOptions.filter(o => o !== item.option);
    } else {
      this.selectedOptions.push(item.option);
    }
    this.selectedChange.emit(this.items.filter(i => this.selectedOptions.includes(i.option)));
    this.dropdownService.close();
  }

  private scrollToNext(item: any, direction: number) {
    const index = _.indexOf(this.items, item);
    const element = this.dropdownItems.toArray()[index];
    if (direction === 1) {
      if (element.nativeElement.offsetTop >= this.elementRef.nativeElement.offsetHeight) {
        this.elementRef.nativeElement.scrollTop += element.nativeElement.offsetHeight;
      }
    } else {
      this.elementRef.nativeElement.scrollTop -= element.nativeElement.offsetHeight;
    }
  }
}
